import { render, staticRenderFns } from "./TriangleRewardsCard.vue?vue&type=template&id=6a8737ea&scoped=true&"
import script from "./TriangleRewardsCard.vue?vue&type=script&lang=js&"
export * from "./TriangleRewardsCard.vue?vue&type=script&lang=js&"
import style0 from "./TriangleRewardsCard.vue?vue&type=style&index=0&id=6a8737ea&lang=scss&scoped=true&"
import style1 from "./TriangleRewardsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8737ea",
  null
  
)

export default component.exports